export default class Service {
  id: number = 0;
  name: string = "";
  code: string = "";
  availableUsers: number = 0;
  arise: string = "";
  service: string = "";
  viewAllServiceTasks: boolean = false;

  public constructor(params: Params = {}) {
    if (params.id) this.id = params.id;
    if (params.name) this.name = params.name;
    if (params.code) this.code = params.code;
    if (params.availableUsers) this.availableUsers = params.availableUsers;
    if (params.arise) this.arise = params.arise;
    if (params.service) this.service = params.service;
    if (params.viewAllServiceTasks) this.viewAllServiceTasks = params.viewAllServiceTasks;
  }
}

interface Params {
  id?: number;
  name?: string;
  code?: string;
  availableUsers?: number;
  arise?: string;
  service?: string;
  viewAllServiceTasks?: boolean;
}
